import React, { useState, useEffect, useContext } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../../../Service";
import DataClient from "../../../../../Service/general_data_service";
import Select from "@material-ui/core/Select/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CloseIcon from "@material-ui/icons/Close";
import InputLabel from "@material-ui/core/InputLabel";

import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CustomSelect from "../../../../../Components/CustomSelect";
import CustomInput from "../../../../../Components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { FormControl } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { FormHelperText } from "@material-ui/core";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
    // width: "400px",
    padding: theme.spacing(3),
  },
  title: {
    textTransform: "initial",
  },
  actionButtons: {
    paddingTop: "35px",
    textAlign: "right",
    "& button": {
      // marginRight: "20px",
    },
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function ManageCoachingRequest(props) {
  const classes = useStyles();
  const { action, handleClose, data, data1, fieldAction, descAction, currentSelectionDesc } = props;

  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [feildName, setFeildName] = useState("");
  const [openNewFeild, setOpenNewFeild] = useState("");
  // const message = useContext(ToastMessageContext);
  const global_data_common = useSelector((state) => state.commonReducer);
  const [loading, setLoading] = useState(false);
  const [openNewFeildDialog, setOpenNewFeildDialog] = useState(false);
  const [feildType, setFieldType] = useState("");
  const [internalJobTitlesArr, setInternalJobTitlesArr] = useState([]);
  const [currenciesArr, setCurrenciesArr] = useState([]);
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState([]);

  const dataObject = {
    section_name: "",
    // default: '',
  };
  const dataObjectField = {
    field_name: "",
    field_type: "",
    dropdown_values: "",
    description: ""
  };
  const [userData, setUserData] = useState(dataObject);
  const [userDataField, setUserDataField] = useState(dataObjectField);

  useEffect(() => {
    setUserData(data);
    setUserDataField(data1);
  }, [data, data.id]);

  const setOpen = () => {
    setOpenNewFeild("open");
    setOpenNewFeildDialog(true);
  };
  const handleNewFeildClose = () => {
    setOpenNewFeildDialog(false);
  };

  const handleCreate = (formData) => {
    var flag = true;
    if (userData.section_name === "") {
      flag = false;
    }
    if (flag) {
      setSubmitClickFlag(true);
      const statusData = {
        coaching_request_form_id: props.crfSectionId,
        default: false,
        ...userData,
      };
      DataService.createData(statusData, "crf_form_sections")
        .then((res) => {
          if (res.success) {
            handleClose(res.data);
            dispatch(showSnackbar("success", ["Success!"]));
            props.CoachinRate();
          } else {
            setSubmitClickFlag(true);
            setLoading(false);
          }
        })
        .catch((err) => {
          setErrorMessage(err.errors);
          setLoading(false);
        });
    } else {
      setSubmitClickFlag(true);
    }
  };

  const handleUpdate = (formData) => {
    var flag = true;
    if (userData.section_name === "") {
      flag = false;
    }

    if (flag) {
      setSubmitClickFlag(true);
      // setLoading(true);
      const statusData = {
        coaching_request_form_id: props.crfSectionId,
        section_name: userData.section_name,
      };
      DataClient.update(statusData, `/crf_form_sections/${data.id}`)
        .then((res) => {
          if (res) {
            // setLoading(true);
            dispatch(showSnackbar("success", ["Success!"]));
            props.CoachinRate();
            handleClose();
          } else {
            setSubmitClickFlag(true);
            setLoading(false);
          }
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setSubmitClickFlag(true);
    }
  };

  const setInputState = (inputStateValue, inputId) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
  };
  const setInputStateField = (inputStateValue, inputId) => {
    setUserDataField({ ...userDataField, [inputId]: inputStateValue });
  };
  const onChangeItem = (selectedItemValue, inputId) => {
    setUserDataField({
      ...userDataField,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };
  const handleCreateNewFeild = (e) => {
    var flag = true;
    if (userDataField.field_name === "") {
      flag = false;
    }
    if (flag) {
      setSubmitClickFlag(true);
      const statusData = {
        crf_form_section_id: data.id,
        // default: false,
        // ...userDataField,

        field_type: userDataField.field_type,
        field_value: userDataField.field_value,
        dropdown_values: userDataField.dropdown_values,
      };
      DataService.createData(statusData, "crf_fields")
        .then((res) => {
          if (res.success) {
            dispatch(showSnackbar("success", ["Success!"]));
            props.CoachinRate();
            handleClose(res.data);
          } else {
            setSubmitClickFlag(true);
            setLoading(false);
          }
        })
        .catch((err) => {
          setErrorMessage(err.errors);
          setLoading(false);
        });
    } else {
      setSubmitClickFlag(true);
    }
  };
  const handleUpdateFeild = (formData) => {
    var flag = true;
    if (userData.section_name === "") {
      flag = false;
    }

    if (flag) {
      setSubmitClickFlag(true);
      const statusData = {
        // id:data1.id,
        // crf_form_section_id: props.crfSectionId,
        field_type: userDataField.field_type || feildType,
        field_value: userDataField.field_value,
        dropdown_values: userDataField.dropdown_values,
        description: userDataField.description
      };
      DataClient.update(statusData, `/crf_fields/${data1.id}`)
        .then((res) => {
          if (res) {
            dispatch(showSnackbar("success", ["Success!"]));
            // setLoading(true);
            props.CoachinRate();
            handleClose();
          } else {
            setSubmitClickFlag(true);
            setLoading(false);
          }
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setSubmitClickFlag(true);
    }
  };
  const handleDeleteFeild = () => {
    setLoading(true);
    DataService.deleteDirectFeild(`crf_fields/${data1.id}`)
      .then((res) => {
        if (res.success) {
          handleClose(res.data);
          props.CoachinRate();
          // message.showToastMessage({ open: true, message: "New Supplier added
          // successfully", variant: "success" });   props.getSupplierList();
        } else {
          // message.showToastMessage({ open: true, message: res.errors ?
          // res.errors.join(',') : "Something went wrong. Try Again", variant: "error" });
          setLoading(false);
        }
      })
      .catch(() => {
        // message.showToastMessage({ open: true, message: "Something went wrong. Try
        // Again", variant: "error" });
        setLoading(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    for (const iterator of formData) {
      console.log(iterator);
    }

    if (action === "create") {
      handleCreate(formData);
    } else if (action === "edit") {
      handleUpdate(formData);
    } else if (fieldAction === "createField") {
      handleCreateNewFeild(formData);
    } else if (fieldAction === "editField") {
      handleUpdateFeild(formData);
    } else if (fieldAction === "deleteField") {
      handleDeleteFeild();
    }
    else {
      handleUpdate(formData);
    }
  };
  const handleFieldChange = (event) => {
    setFieldType(event.target.value);
    console.log(`event.target.value`, event.target.value);
  };
  return (
    <div>
      <Dialog
        maxWidth={"sm"}
        style={
          {
            // height: "70%",
          }
        }
        open={true}
        fullWidth
        // disableBackdropClick
        // disableEscapeKeyDown
        onClose={handleClose}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle
          style={{
            paddingTop: "30px",
            paddingLeft: "47px",
            // textTransform:"initial"
          }}
          id="customized-dialog-title"
          onClose={handleClose}
        >
          {/* {action === "edit" ? "Edit CRF" : "Create CRF"} */}
          {action === "create" && "Create CRF"}
          {action === "edit" && "Update CRF"}
          {fieldAction === "createField" && "Create field"}
          {fieldAction === "editField" && "Update field"}
          {descAction === "editDesc" && "Edit Description"}
        </DialogTitle>
        <DialogContent
          style={
            {
              // margin: "0px auto",
            }
          }
        >
          {descAction === "editDesc" && !action && !fieldAction && (
            <React.Fragment>
              <Grid item xs={3}>
                <Typography
                  variant="h2"
                  color="secondary"
                  className={classes.title}
                >
                  Description name
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <CustomInput
                  autoFocus
                  id="description"
                  helperText={
                    submitClickFlag &&
                      (currentSelectionDesc === "" ||
                        currentSelectionDesc === undefined)
                      ? "Please enter description"
                      : ""
                  }
                  error={
                    submitClickFlag &&
                      (currentSelectionDesc === "" ||
                        currentSelectionDesc === undefined)
                      ? true
                      : false
                  }
                  parentcall={setInputState}
                  variant="outlined"
                  multiline
                  rows={4}
                  style={{ backgroundColor: "#fff" }}
                  defaultValue={currentSelectionDesc}
                  placeholder="Description"
                />
              </Grid>
            </React.Fragment>
          )}
          {action !== "delete" && fieldAction !== "deleteField" ? (
            <div className={classes.formWrapper}>
              <Typography
                variant="h2"
                color="secondary"
                className={classes.title}
              >
                {/* {action !== "edit" ? `${action}Modules` :''}  */}
              </Typography>
              <form onSubmit={handleSubmit}>
                <Grid
                  container
                  spacing={1}
                  alignItems={"center"}
                  justify={"flex-start"}
                >

                  {(action === "create" || action === "edit") && (
                    <React.Fragment>
                      <Grid item xs={3}>
                        <Typography
                          variant="h2"
                          color="secondary"
                          className={classes.title}
                        >
                          Section name
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <CustomInput
                          autoFocus
                          id="section_name"
                          helperText={
                            submitClickFlag &&
                              (userData.section_name === "" ||
                                userData.section_name === undefined)
                              ? "Please enter section"
                              : ""
                          }
                          error={
                            submitClickFlag &&
                              (userData.section_name === "" ||
                                userData.section_name === undefined)
                              ? true
                              : false
                          }
                          parentcall={setInputState}
                          variant="outlined"
                          style={{ backgroundColor: "#fff" }}
                          defaultValue={userData.section_name}
                          placeholder="Section name"
                        />
                      </Grid>

                      {/* <FormHelperText style={{textAlign:'center', color:'red'}}>{errorMessage ? errorMessage:''}</FormHelperText> */}
                    </React.Fragment>
                  )}

                  {fieldAction && (
                    <React.Fragment>
                      {userDataField.field_value !== "Description" && <React.Fragment><Grid item xs={3}>
                        <Typography
                          variant="h2"
                          color="secondary"
                          className={classes.title}
                        >
                          Field name
                        </Typography>
                      </Grid>
                        <Grid item xs={9}>
                          <CustomInput
                            autoFocus
                            id="field_value"
                            helperText={
                              submitClickFlag &&
                                (userDataField.field_value === "" ||
                                  userDataField.field_value === undefined)
                                ? "Please enter field name"
                                : ""
                            }
                            error={
                              submitClickFlag &&
                                (userDataField.field_value === "" ||
                                  userDataField.field_value === undefined)
                                ? true
                                : false
                            }
                            parentcall={setInputStateField}
                            variant="outlined"
                            style={{ backgroundColor: "#fff" }}
                            defaultValue={userDataField.field_value}
                            placeholder="Field name"
                          />
                        </Grid>   </React.Fragment>}

                      {/* <FormHelperText style={{textAlign:'center', color:'red'}}>{errorMessage ? errorMessage:''}</FormHelperText> */}
                      <Grid item xs={3}>
                        <Typography
                          variant="h2"
                          color="secondary"
                          className={classes.title}
                        >
                          {userDataField.field_value === "Description" ? "Edit Description" : "Field type"}
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>

                        {userDataField.field_value === "Description" ?
                          <CustomInput
                            id="description"
                            helperText={
                              submitClickFlag &&
                                (userDataField.description === "" ||
                                  userDataField.description === undefined)
                                ? "Please enter description"
                                : ""
                            }
                            error={
                              submitClickFlag &&
                                (userDataField.description === "" ||
                                  userDataField.description === undefined)
                                ? true
                                : false
                            }
                            multiline
                            rows={4}
                            parentcall={setInputStateField}
                            variant="outlined"
                            style={{ backgroundColor: "#fff" }}
                            defaultValue={userDataField.field_value === "Description" ? userDataField.description : ""}
                            placeholder="Description"
                          />
                          :
                          <CustomSelect
                            id="field_type"
                            displayEmpty
                            variant="outlined"
                            labelText="Select a value"
                            defaultValue={userDataField.field_type}
                            itemArr={["Drop down", "Text", "Text area"]}
                            helperText={
                              submitClickFlag &&
                                (userDataField.field_type === "" ||
                                  userDataField.field_type === undefined)
                                ? "* Please Select a value"
                                : ""
                            }
                            error={
                              submitClickFlag &&
                                (userDataField.field_type === "" ||
                                  userDataField.field_type === undefined)
                                ? true
                                : false
                            }
                            parentcall={onChangeItem}
                          />
                        }
                      </Grid>
                      {userDataField.field_type === "Drop down" && (
                        <React.Fragment>
                          {" "}
                          <Grid item xs={3}>
                            <Typography
                              variant="h2"
                              color="secondary"
                              className={classes.title}
                            >
                              Dropdown values
                            </Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <CustomInput
                              id="dropdown_values"
                              helperText={
                                submitClickFlag &&
                                  (userDataField.dropdown_values === "" ||
                                    userDataField.dropdown_values === undefined)
                                  ? "Please enter Dropdown values"
                                  : ""
                              }
                              error={
                                submitClickFlag &&
                                  (userDataField.dropdown_values === "" ||
                                    userDataField.dropdown_values === undefined)
                                  ? true
                                  : false
                              }
                              parentcall={setInputStateField}
                              variant="outlined"
                              style={{ backgroundColor: "#fff" }}
                              defaultValue={userDataField.dropdown_values}
                              placeholder="Field name"
                            />
                          </Grid>{" "}
                        </React.Fragment>
                      )}
                      <FormHelperText
                        style={{ textAlign: "center", color: "red" }}
                      >
                        {errorMessage ? errorMessage : ""}
                      </FormHelperText>
                    </React.Fragment>
                  )}
                </Grid>

                <div className={classes.actionButtons}>
                  <Button
                    disableElevation
                    disabled={loading}
                    type="button"
                    variant={"contained"}
                    onClick={handleClose}
                    style={{ textTransform: "initial" }}
                  >
                    Cancel
                  </Button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <Button
                    disableElevation
                    disabled={loading}
                    type="submit"
                    variant={"contained"}
                    color="primary"
                    style={{ textTransform: "initial" }}
                  >
                    {action === "create" && "Create"}
                    {action === "edit" && "Update"}
                    {fieldAction === "createField" && "Create"}
                    {fieldAction === "editField" && "Update"}
                    {descAction === "editDesc" && "Update"}
                    {/* {fieldAction === "createField" && action === '' ? "Create" : "Update"} */}
                  </Button>
                </div>
              </form>
            </div>
          ) : (
            fieldAction === "deleteField" && (
              <div className={classes.formWrapper}>
                <Typography variant="h2">
                  Warning! Deleting this field will delete both the field and
                  their type from the list. Are you sure?
                </Typography>
                <div className={classes.actionButtons}>
                  <Button
                    disableElevation
                    disabled={loading}
                    type="button"
                    variant={"contained"}
                    onClick={handleClose}
                    style={{ textTransform: "initial" }}
                  >
                    Cancel
                  </Button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <Button
                    disableElevation
                    disabled={loading}
                    type="button"
                    variant={"contained"}
                    color="primary"
                    onClick={handleDeleteFeild}
                    style={{ textTransform: "initial" }}
                  >
                    Yes, confirm
                  </Button>
                </div>
              </div>
            )
          )}
        </DialogContent>
      </Dialog>
      )
    </div>
  );
}

export default ManageCoachingRequest;
